"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapLocaleToLocaleCode = exports.allLocales = void 0;
exports.allLocales = ['en', 'de', 'fr', 'sq'];
const mapLocaleToLocaleCode = (locale) => {
    var _a;
    const defaultLocale = 'de';
    return (_a = exports.allLocales.find(x => locale === null || locale === void 0 ? void 0 : locale.startsWith(x))) !== null && _a !== void 0 ? _a : defaultLocale;
};
exports.mapLocaleToLocaleCode = mapLocaleToLocaleCode;
//# sourceMappingURL=locale.js.map